import React from 'react'
import "../../styles/ComponentsStyles/Universal/CardHeader.style.css"
import PropTypes from 'prop-types'
const CardHeader = ({ title, actionBtn, headerStyle }) => {
    return (
        <div className="cardHeader">
            <div className="cardHeaderDetailsContainer" style={headerStyle}>
                <h3>{title}</h3>
                {actionBtn}
            </div>
        </div>
    )
}

export default CardHeader
CardHeader.propTypes = {
    title: PropTypes.string.isRequired,
    actionBtn: PropTypes.element.isRequired,
    headerStyle: PropTypes.object
}